var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m50 91.668c11.051 0 21.648-4.3906 29.461-12.207 7.8164-7.8125 12.207-18.41 12.207-29.461s-4.3906-21.648-12.207-29.461c-7.8125-7.8164-18.41-12.207-29.461-12.207s-21.648 4.3906-29.461 12.207c-7.8164 7.8125-12.207 18.41-12.207 29.461s4.3906 21.648 12.207 29.461c7.8125 7.8164 18.41 12.207 29.461 12.207zm-4.168-62.5c0-2.3008 1.8672-4.168 4.168-4.168s4.168 1.8672 4.168 4.168v29.168-0.003907c0 2.3008-1.8672 4.168-4.168 4.168s-4.168-1.8672-4.168-4.168zm4.168 37.5c1.6836 0 3.2031 1.0156 3.8477 2.5703 0.64844 1.5586 0.28906 3.3516-0.90234 4.543-1.1914 1.1914-2.9844 1.5469-4.5391 0.90234-1.5586-0.64453-2.5742-2.1641-2.5742-3.8516 0-2.3008 1.8672-4.1641 4.168-4.1641z"}));
}

Alert.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Alert;

Alert.default = Alert;
